import React, { useEffect, useState } from "react";
import Loader from "../../loader";
import HomeContent from "./homeContent";
import "./homePage.scss";
import NewsSection from "./newsSection";
import SliderSection from "./sliderSection";
export default function HomePage() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div>
      <>
        <SliderSection />
        <HomeContent />
        <NewsSection />
      </>
    </div>
  );
}
